module.exports = __webpack_public_path__ + "img/additional-info-icon.66803295.svg";